// the 'chain' is a mecanism to 'squash' multiple functions as one
// the intended use case is to merge many hook functions into a sequence of hooks.
export const useChain = (functions = []) => {
  // allow undefined hook input to enable a simpler declaration syntax
  const sanitizedFns = functions.filter((f) => typeof f === "function");

  // hook functions will be called in the order they are provided
  // the response will be passed to each as a parameter
  // no error management is present to conserve the error behaviour
  const chain = (response) => {
    sanitizedFns.forEach((fn) => fn(response));
  };

  return chain;
};
